import { render, staticRenderFns } from "./OrderCopyPaste.vue?vue&type=template&id=739f6f5f&"
import script from "./OrderCopyPaste.vue?vue&type=script&lang=js&"
export * from "./OrderCopyPaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports